import React, { useEffect } from 'react'

import {
  useLocation,
  Redirect,
  Switch,
  useParams
} from 'react-router-dom'

import { useDispatch, useSelector } from 'react-redux'
import { selectElectronLocale } from '@selectors'
import { FETCH_ELECTRON_LOCALE, LOCATION_PERMISSION_CHECK, SET_ELECTRON, FETCH_ELECTRON_OS_USER } from '../../redux/actions/types'

import SafeWalkOffCampus from '@components/safewalk-off-campus/safewalk-off-campus.component'
import SafeWalkOnCampus from '@components/safewalk-on-campus/safewalk-on-campus.component'
import ChatMessages from '@components/chat-messages/chat-messages.component'
import Engage from '@components/engage/engage.component'
import EngagementDetail from '@components/engagement-detail/engagement-detail.component'
import EngagementSend from '@components/engage-send/engage-send.component'
import EngagementSuggestionDetail from '@components/engagement-suggestion-detail/engagement-suggestion-detail.component'
import Header from '@components/header/header.component'
import SafeWalkContainer from '@components/safewalk-container/safewalk-container.component'
import MatchRoute from '@components/match-route/match-route.component'
import PriorityConnect from '@components/priority-connect/priority-connect.component'
import ProtectedRoute from '@components/protected-route/protected-route.component'
import Resources from '@components/resources/resources.component'
import SafeWalkButton from '@components/safewalk-button/safewalk-button.component'
import TabBar from '@components/tab-bar/tab-bar.component'
import Tips from '@components/tips/tips.component'
import i18n from 'i18n-js'

import { SvgGradientFills } from '@omnilert/components'

import useStyles from './push-container.style'

const PushContainer = (props) => {
  const array = useLocation().pathname.split('/')
  const pathName = array[array.length - 1]

  const classes = useStyles({ props, pathName })

  const { personalAccessCode } = useParams()

  const dispatch = useDispatch()

  const isElectron = !!window.api?.isElectron

  const electronLocale = useSelector(selectElectronLocale)

  useEffect(() => {
    dispatch({ type: SET_ELECTRON, payload: { isElectron } })
    dispatch({ type: LOCATION_PERMISSION_CHECK })
    if (isElectron) {
      dispatch({ type: FETCH_ELECTRON_LOCALE })
      dispatch({ type: FETCH_ELECTRON_OS_USER })
      if (electronLocale) {
        i18n.locale = electronLocale
      }
    }
  }, [dispatch, isElectron, electronLocale])

  return (
    <div className={classes.container}>
      <Header />
      <div className={classes.routesContainer}>
        <Switch>
          <Redirect
            exact
            from={`/${personalAccessCode}`}
            to={`/${personalAccessCode}/messages`}
          />
          <MatchRoute
            exact
            path='/:personalAccessCode/messages'
          >
            <ChatMessages />
          </MatchRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/tips'
          >
            <Tips />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/resources'
          >
            <Resources />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/safewalk'
          >
            <SafeWalkContainer />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/safewalk/on-campus'
          >
            <SafeWalkOnCampus />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/safewalk/off-campus'
          >
            <SafeWalkOffCampus />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/priority-connect/:conferenceAlias'
          >
            <PriorityConnect />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/engage'
          >
            <Engage />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/engage/:engagementId'
          >
            <EngagementDetail />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/engage/:engagementId/reply/:replyGuid/send'
          >
            <EngagementSend />
          </ProtectedRoute>
          <ProtectedRoute
            exact
            path='/:personalAccessCode/engage/:engagementId/reply/:replyGuid'
          >
            <EngagementSuggestionDetail />
          </ProtectedRoute>
          <Redirect
            from='/**/'
            to={`${process.env.REACT_APP_BASE_URL}/404`}
          />
        </Switch>
      </div>
      <SafeWalkButton />
      <TabBar />
      <SvgGradientFills />
    </div>
  )
}

export default PushContainer
